import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable prefer-destructuring */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Table, FundsDepositsTableHeader, useUser } from 'components';
import { getCurrencyConfig, showApiError } from 'utils';
import { getAllFranchiseeFunds, postFranchiseeFundsDeposit, exportAllFranchiseeFunds } from 'services';
import { fundsTableWrap } from './styles';
import { fundsListColumns } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeFunds = function FranchiseeFunds(_ref) {
  var id = _ref.id,
      onAddSubtract = _ref.onAddSubtract;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var tableRef = useRef();

  var fetchAllFunds = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllFranchiseeFunds(_objectSpread(_objectSpread({}, tableOptions), {}, {
                franchisee: id
              }));

            case 2:
              _yield$getAllFranchis = _context.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              return _context.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAllFunds(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDeposit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values, type) {
      var _getCurrencyConfig;

      var amount, isAdd, _yield$postFranchisee, _yield$postFranchisee2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              amount = values.amount;
              isAdd = type === 'add';
              _context2.next = 4;
              return postFranchiseeFundsDeposit({
                amount: "".concat(isAdd ? '' : '-').concat(amount),
                currency: (_getCurrencyConfig = getCurrencyConfig()) === null || _getCurrencyConfig === void 0 ? void 0 : _getCurrencyConfig.defaultCurrency,
                franchisee_id: id
              });

            case 4:
              _yield$postFranchisee = _context2.sent;
              _yield$postFranchisee2 = _slicedToArray(_yield$postFranchisee, 2);
              err = _yield$postFranchisee2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 9:
              tableRef.current.getData();
              _isFunction(onAddSubtract) && onAddSubtract();

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDeposit(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var exportFunds = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$exportAllFranc, _yield$exportAllFranc2, res, err, url;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return exportAllFranchiseeFunds({
                franchisee: id,
                "export": 1
              });

            case 2:
              _yield$exportAllFranc = _context3.sent;
              _yield$exportAllFranc2 = _slicedToArray(_yield$exportAllFranc, 2);
              res = _yield$exportAllFranc2[0];
              err = _yield$exportAllFranc2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(res);
              window.open(url, '_blank', 'noreferrer', 'noopener');

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function exportFunds() {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: fundsTableWrap
  }, ___EmotionJSX(Table, {
    ref: tableRef,
    hasPagination: true,
    getDataMethod: fetchAllFunds,
    columns: fundsListColumns,
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: function filterBar(data) {
      return ___EmotionJSX(FundsDepositsTableHeader, _extends({}, data, {
        canViewForm: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant,
        onDeposit: handleDeposit,
        label: "\u0412\u044A\u0432\u0435\u0434\u0438 \u0421\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
        placeholder: "\u0421\u0443\u043C\u0430 \u043D\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0442\u0430",
        addButtonText: "\u0414\u0430\u0439 \u0421\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
        takeButtonText: "\u0412\u044A\u0440\u043D\u0438 \u0421\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
        onExport: exportFunds
      }));
    },
    margin: "0 2em",
    pageSize: 20
  }));
};

FranchiseeFunds.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onAddSubtract: PropTypes.func
};
export default FranchiseeFunds;